define('shared/util/cq/getElementByDialog',[],function(){
    return function( dialog ){
        return dialog && 
            dialog.initialConfig && 
            dialog.initialConfig.responseScope && 
            dialog.initialConfig.responseScope.el && 
            dialog.initialConfig.responseScope.el.dom;
    }
});
